exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.home-trainers[data-v-5d21dc5f]{width:100%;padding:50px;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n@media(max-width: 769px){\n.home-trainers[data-v-5d21dc5f]{margin-bottom:12px\n}\n}\n.trainer-box[data-v-5d21dc5f]{-webkit-box-sizing:border-box;box-sizing:border-box\n}\n.trainer-box .trainer-padding[data-v-5d21dc5f]{background-color:#fff;padding:12px;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n.trainer-box .trainer-inner[data-v-5d21dc5f]{background-color:#e9e9e9;padding:12px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n.context-colreps .trainer-box .trainer-inner[data-v-5d21dc5f]{background-color:#4d4d4d\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d21dc5f","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home_trainers/HomeTrainers.vue
// module id = Vyrf
// module chunks = 1